import * as actionTypes from "./actionTypes";



export const loadDropngoCategory = data => {

  return {
    type: actionTypes.LOAD_DROPNGO_CATEGORY,
    data
  };
};

export const loadDropngoCategorySuccess = data => {
  return {
    type: actionTypes.LOAD_DROPNGO_CATEGORY_SUCCESS,
    data
  };
};

export const loadDropngoCategoryFail = () => {
  return {
    type: actionTypes.LOAD_DROPNGO_CATEGORY_FAIL
  };
};


export const loadDropngoCategoryAll = data => {

  return {
    type: actionTypes.LOAD_DROPNGO_CATEGORY_ALL,
    data
  };
};

export const loadDropngoCategoryAllSuccess = data => {
  return {
    type: actionTypes.LOAD_DROPNGO_CATEGORY_ALL_SUCCESS,
    data
  };
};

export const loadDropngoCategoryAllFail = () => {
  return {
    type: actionTypes.LOAD_DROPNGO_CATEGORY_ALL_FAIL
  };
};


export const addDropngoCategory = data => {
  return {
    type: actionTypes.ADD_DROPNGO_CATEGORY,
    data
  };
};

export const addDropngoCategorySuccess = () => {
  return {
    type: actionTypes.ADD_DROPNGO_CATEGORY_SUCCESS
  };
};

export const addDropngoCategoryFail = () => {
  return {
    type: actionTypes.ADD_DROPNGO_CATEGORY_FAIL
  };
};

export const editDropngoCategory = (id,data) => {
  return {
    type: actionTypes.EDIT_DROPNGO_CATEGORY,
    id,
    data
  };
};

export const editDropngoCategorySuccess = () => {
  return {
    type: actionTypes.EDIT_DROPNGO_CATEGORY_SUCCESS
  };
};

export const editDropngoCategoryFail = () => {
  return {
    type: actionTypes.EDIT_DROPNGO_CATEGORY_FAIL
  };
};

export const deleteDropngoCategory = (id, data) => {
  return {
    type: actionTypes.DELETE_DROPNGO_CATEGORY,
    id,
    data
  };
};

export const deleteDropngoCategorySuccess = () => {
  return {
    type: actionTypes.DELETE_DROPNGO_CATEGORY_SUCCESS
  };
};

export const deleteDropngoCategoryFail = () => {
  return {
    type: actionTypes.DELETE_DROPNGO_CATEGORY_FAIL
  };
};



export const loadDropngoCategoryEffectiveDateList = data => {

  return {
    type: actionTypes.LOAD_DROPNGO_PRICE_EFFECTIVE_DATE_LIST,
    data
  };
};

export const loadDropngoCategoryEffectiveDateListSuccess = data => {

  return {
    type: actionTypes.LOAD_DROPNGO_PRICE_EFFECTIVE_DATE_LIST_SUCCESS,
    data
  };
};

export const loadDropngoCategoryEffectiveDateListFail = () => {
  return {
    type: actionTypes.LOAD_DROPNGO_PRICE_EFFECTIVE_DATE_LIST_FAIL
  };
};



export const dropngoCategoryPriceControlLoad = (data) => {
  return {
    type: actionTypes.DROPNGO_CATEGORY_PRICE_CONTROL_LOAD,
    data
  };
};

export const dropngoCategoryPriceControlLoadSuccess = (data) => {
  return {
    type: actionTypes.DROPNGO_CATEGORY_PRICE_CONTROL_LOAD_SUCCESS,
    data
  };
};

export const dropngoCategoryPriceControlLoadFail = () => {
  return {
    type: actionTypes.DROPNGO_CATEGORY_PRICE_CONTROL_LOAD_FAIL
  };
};

export const dropngoCategoryPriceControlSet = (id, data) => {
  return {
    type: actionTypes.DROPNGO_CATEGORY_PRICE_CONTROL_SET,
    id,
    data
  };
};

export const dropngoCategoryPriceControlSetSuccess = () => {
  return {
    type: actionTypes.DROPNGO_CATEGORY_PRICE_CONTROL_SET_SUCCESS
  };
};

export const dropngoCategoryPriceControlSetFail = () => {
  return {
    type: actionTypes.DROPNGO_CATEGORY_PRICE_CONTROL_SET_FAIL
  };
};


export const dropngoCategoryPriceRemove = (id,data) => {
  return {
    type: actionTypes.DELETE_DROPNGO_CATEGORY_PRICE,
    id,
    data
  };
};

export const dropngoCategoryPriceRemoveSuccess = () => {
  return {
    type: actionTypes.DELETE_DROPNGO_CATEGORY_PRICE_SUCCESS
  };
};

export const dropngoCategoryPriceRemoveFail = () => {
  return {
    type: actionTypes.DELETE_DROPNGO_CATEGORY_PRICE_FAIL
  };
};


export const getDropngoCategoryPricePDF = (data) => {
  return {
    type: actionTypes.GET_DROPNGO_CATEGORY_PRICE_PDF,
    data,
  };
};

export const getDropngoCategoryPricePDFSuccess = data => {
  return {
    type: actionTypes.GET_DROPNGO_CATEGORY_PRICE_PDF_SUCCESS,
    data
  };
};

export const getDropngoCategoryPricePDFFail = () => {
  return {
    type: actionTypes.GET_DROPNGO_CATEGORY_PRICE_PDF_FAIL
  };
};
